export default __webpack_public_path__ + "static/media/svg-5.7675e4d2.svg";